module.exports = __webpack_public_path__ + "static/media/nike-land-of-new-football-new-football-news-1.74c417df.mp4";